import React, { ReactNode } from 'react';

// Config
import { getFeatureFlags } from '~/App/config/featureFlags';
import { FeatureToggleContext } from './FeatureToggleContext';

type Props = {
  children: ReactNode;
};

export function FeatureToggleProvider({ children }: Props) {
  return (
    <FeatureToggleContext.Provider
      value={getFeatureFlags()}
      children={children}
    />
  );
}
